import { useCallback, useState } from 'react';
import { getMessage } from '../messaging/MESSAGE';
import { BlobBleadImage, BlobImage } from './blob/Blob.styles';
import { BlobKey } from './blob/BlobKey';
import { getColorTheme } from './blob/blobUtils';
import { BlobMessaging } from './BlobMessaging';
import { jsx as _jsx } from "react/jsx-runtime";
export const ImageBlob = ({
  messageKey,
  onImageLoaded = () => {}
}) => {
  const {
    imageUrl,
    blobBleed: bleed,
    blobBleedConfig,
    colorThemeOption,
    imageWidth,
    imageHeight,
    showBorder = false
  } = getMessage(messageKey);
  const [imageLoaded, setImageLoaded] = useState(false);
  const onLoadCallback = useCallback(() => {
    onImageLoaded();
    setImageLoaded(true);
  }, [onImageLoaded]);
  const renderImage = useCallback(ImageComponent => {
    const colorTheme = getColorTheme(colorThemeOption);
    const attrs = Object.assign({
      bleed,
      blobBleedConfig,
      height: imageHeight
    }, imageWidth && {
      width: imageWidth
    }, {
      responsive: false,
      imageLoaded,
      onLoad: onLoadCallback,
      colorTheme,
      showBorder,
      src: imageUrl
    });
    if (Array.isArray(imageUrl)) {
      attrs.src = imageUrl[imageUrl.length - 1];
      attrs.srcSet = imageUrl.map((src, index) => `${src} ${400 * (index + 1)}w`).join(', ');
      attrs.sizes = '(max-width: 1200px) 100vw, 1200px';
      attrs.clipPath = 'url(#innerBlob)';
    } else {
      attrs.src = imageUrl;
    }
    return /*#__PURE__*/_jsx(ImageComponent, Object.assign({}, attrs));
  }, [bleed, blobBleedConfig, imageHeight, imageWidth, onLoadCallback, imageUrl, imageLoaded, showBorder, colorThemeOption]);
  const renderComponent = () => {
    return renderImage(BlobImage);
  };
  const renderBleed = () => {
    return renderImage(BlobBleadImage);
  };
  return /*#__PURE__*/_jsx(BlobMessaging, {
    blobKey: BlobKey.ImageBlob,
    colorThemeOption: colorThemeOption,
    messageKey: messageKey,
    renderBleed: renderBleed,
    renderComponent: renderComponent
  });
};